/**
 * ================================================================================================
 * >>> **HER 2026-08-28 RULING: A SWIPE AWAY IS A PAUSE, NOT AN ENDING — UNTIL TWO MINUTES.** <<<
 *
 * Her words: *"when someone swipes accidentally off of the live, or a phone call comes in ... show a
 * paused screen, and when the person jumps back the live will resume broadcasting ... audio and
 * video ... A timeout period of two minutes will automatically end the live if they are inactive for
 * two minutes. But I do not want it to end if they have to swipe off the screen real quick and come
 * right back."*
 *
 * THREE FACTS, NOT ONE (R18): she is HERE, she is AWAY AND COMING BACK, or she has been away long
 * enough that the broadcast is over. A build with two states either ends her stream on a phone call
 * or leaves a dead circle up all afternoon.
 *
 * **THIS MODULE IMPORTS NOTHING**, which is the entry requirement that lets a FAST fixture RUN every
 * law in it rather than read one out of a component (R146).
 * ================================================================================================
 */

/** Her two minutes, in one place. */
export const LIVE_AWAY_LIMIT_MS = 2 * 60 * 1000;

export const LIVE_PRESENCE = { LIVE: "live", PAUSED: "paused", ENDED: "ended" };

/**
 * What should happen to a broadcast, given how long she has been off the screen.
 *
 * **PRESENCE, NEVER TRUTHINESS (R53/R136/R137), AND THE DIRECTION IS R19's CHEAP ONE.** `awayMs`
 * arrives from a clock subtraction, so a NaN, a negative or a value that is not a number at all must
 * read as *still here* rather than as *two minutes gone* — an unreadable duration that ends her
 * broadcast is the failure she cannot get back, and one that keeps it up costs her a tap on End.
 */
export function livePresenceAction({ hidden = false, awayMs = 0 } = {}) {
  if (hidden !== true) return LIVE_PRESENCE.LIVE;
  const away = typeof awayMs === "number" && Number.isFinite(awayMs) ? awayMs : 0;
  // AT the limit is not PAST it: a phone call answered at exactly two minutes is the case her
  // sentence is about, and the boundary is declared rather than left to a stray `>=`.
  return away > LIVE_AWAY_LIMIT_MS ? LIVE_PRESENCE.ENDED : LIVE_PRESENCE.PAUSED;
}

/**
 * Should her tracks be sending right now?
 *
 * Her clause is *"audio and video"*, both, and the ENABLED flag rather than a stop: a stopped track
 * cannot be restarted, so ending the pause would need a fresh `getUserMedia` and a re-negotiation —
 * which is a new camera permission prompt on a phone call she is already annoyed by. Disabled tracks
 * resume instantly and the PeerConnection never notices.
 */
export function tracksShouldSend(state) {
  return state === LIVE_PRESENCE.LIVE;
}

/** Does the paused card show? One reader, so the screen and a gate cannot disagree (R28/R29). */
export function showsPausedCard(state) {
  return state === LIVE_PRESENCE.PAUSED;
}
